import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const MessagesIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M16.7025 11.4524V9.56239H14.8125V11.4524H16.7025ZM12.9225 11.4524V9.56239H11.0775V11.4524H12.9225ZM9.18751 11.4524V9.56239H7.29751V11.4524H9.18751ZM19.515 3.01489C20.025 3.01489 20.46 3.19489 20.82 3.55489C21.18 3.91489 21.36 4.34989 21.36 4.85989V16.1099C21.36 16.6199 21.18 17.0624 20.82 17.4374C20.46 17.8124 20.025 17.9999 19.515 17.9999H6.37501L2.64001 21.7349V4.85989C2.64001 4.34989 2.82001 3.91489 3.18001 3.55489C3.54002 3.19489 3.97501 3.01489 4.48501 3.01489H19.515Z'
                fill='currentColor'
            />
        </>
    ),
})

MessagesIcon.displayName = 'MessagesIcon'
